export default __webpack_public_path__ + "static/media/mongodb.788ba14a.png";